export default "__VITE_ASSET__IUzsu3fi__"